"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingSpinner = void 0;
var React = require("react");
var LoadingSpinner = function () {
    var loadingIndicatorStyles = [
        '.code-split-loading { display: block; height: 100vh; padding-top: 30vh; }',
        '.code-split-loading > span, .code-split-loading > img { display: block; margin-left: auto; margin-right: auto; text-align: center; }',
        '.code-split-loading > img { height: auto; width: 130px; margin-bottom: 1rem; }'
    ];
    return (React.createElement("div", { className: "code-split-loading" },
        React.createElement("span", { className: "uitk-loader", "aria-hidden": true }),
        React.createElement("style", { dangerouslySetInnerHTML: { __html: loadingIndicatorStyles.join('\n') } })));
};
exports.LoadingSpinner = LoadingSpinner;
//# sourceMappingURL=loading-spinner.js.map